"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_hook_form_1 = require("react-hook-form");
var mona_1 = require("@artegeie/design-system/mona");
var useFormattedMessages_1 = __importDefault(require("../../../context/useFormattedMessages"));
var FieldValidationError_1 = require("../FieldValidationError");
var Checkbox = function (_a) {
    var errorType = _a.errorType, _b = _a.errorValues, errorValues = _b === void 0 ? {} : _b, name = _a.name, control = _a.control, label = _a.label;
    var validationMessageKey = "form.validation.".concat(errorType);
    var validationSpecificMessageKey = "form.validation.".concat(name, ".").concat(errorType);
    var validationMessages = (0, useFormattedMessages_1.default)(validationMessageKey, errorValues);
    var validationSpecificMessages = (0, useFormattedMessages_1.default)(validationSpecificMessageKey, errorValues);
    var validationGenericMessage = (0, useFormattedMessages_1.default)('form.validation.generic');
    return (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: name, render: function (_a) {
            var _b = _a.field, onChange = _b.onChange, value = _b.value;
            return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(mona_1.Checkbox, { id: name, onClick: onChange, label: label, checked: value }, void 0), errorType &&
                        (0, jsx_runtime_1.jsx)(FieldValidationError_1.FieldValidationError, { children: (0, jsx_runtime_1.jsx)("span", __assign({ role: 'alert', "aria-label": name }, { children: validationSpecificMessages[validationSpecificMessageKey] || validationMessages[validationMessageKey] || validationGenericMessage['form.validation.generic'] }), void 0) }, void 0)] }, void 0);
        } }, void 0);
};
exports.Checkbox = Checkbox;
exports.default = exports.Checkbox;
